export const GET_COUNTRY_STATE_DEFINITIONS = "GET_COUNTRY_STATE_DEFINITIONS"
export const GET_COUNTRY_STATE_DEFINITIONS_SUCCESS = "GET_COUNTRY_STATE_DEFINITIONS_SUCCESS"
export const GET_COUNTRY_STATE_DEFINITIONS_FAIL = "GET_COUNTRY_STATE_DEFINITIONS_FAIL"


export const ADD_COUNTRY_STATE_DEFINITION = "ADD_COUNTRY_STATE_DEFINITION"
export const ADD_COUNTRY_STATE_DEFINITION_SUCCESS = "ADD_COUNTRY_STATE_DEFINITION_SUCCESS"
export const ADD_COUNTRY_STATE_DEFINITION_FAIL = "ADD_COUNTRY_STATE_DEFINITION_FAIL"

export const UPDATE_COUNTRY_STATE_DEFINITION = "UPDATE_COUNTRY_STATE_DEFINITION"
export const UPDATE_COUNTRY_STATE_DEFINITION_SUCCESS = "UPDATE_COUNTRY_STATE_DEFINITION_SUCCESS"
export const UPDATE_COUNTRY_STATE_DEFINITION_FAIL = "UPDATE_COUNTRY_STATE_DEFINITION_FAIL"

export const DELETE_COUNTRY_STATE_DEFINITION = "DELETE_COUNTRY_STATE_DEFINITION"
export const DELETE_COUNTRY_STATE_DEFINITION_SUCCESS = "DELETE_COUNTRY_STATE_DEFINITION_SUCCESS"
export const DELETE_COUNTRY_STATE_DEFINITION_FAIL = "DELETE_COUNTRY_STATE_DEFINITION_FAIL"

export const API_ERROR = "API_ERROR"
